const prefix = '@retailMedia/advertiserPublisher'

export const ADVERTISERS_LIST = `${prefix}/ADVERTISERS_LIST`
export const PUBLISHERS_LIST = `${prefix}/PUBLISHERS_LIST`

export const types = {
  listAdvertisers: ADVERTISERS_LIST,
  listPublishers: PUBLISHERS_LIST
}
